<template>
  <BaseModal
    small
    testId="fiskaly-enable"
    @close="router.push({ name: 'calendar' })"
    :heading="$t('register.fiskaly_enable_modal.heading')"
  >
    <Flex direction="column">
      <BaseText>{{ $t('register.fiskaly_enable_modal.message') }}</BaseText>
    </Flex>
    <template #footer>
      <BaseButton
        color="inverted"
        :href="helpCenterUrl"
        v-test="'btn-learn-more'"
      >
        {{ $t('global.learn_more') }}
      </BaseButton>
      <BaseButton
        :routerLink="{ name: 'integration-fiskaly' }"
        v-test="'btn-enable'"
      >
        {{ $t('register.fiskaly_enable_modal.button') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script
  lang="ts"
  setup
>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { helpCenterArticleUrl } from '@/helpers/help-center';

const router = useRouter();

const helpCenterUrl = computed(() => helpCenterArticleUrl(16050328));
</script>
